// extracted by mini-css-extract-plugin
module.exports = {"Row":"VendorPartnerCandidateRow_Row__TKO1K"};